var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3426_554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9944 79.9887C62.0826 79.9887 79.9887 62.0826 79.9887 39.9944C79.9887 17.9061 62.0826 0 39.9944 0C17.9061 0 0 17.9061 0 39.9944C0 62.0826 17.9061 79.9887 39.9944 79.9887Z",
    fill: "url(#paint0_linear_3426_554)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.683 65.5172C25.3649 65.5172 12.8462 57.4686 12.5978 50.6392C12.4285 45.7852 18.2758 42.4778 29.5076 41.1006L29.756 43.0986C19.8562 44.3178 14.4717 46.9705 14.6071 50.5715C14.7877 55.7415 26.0309 63.5078 40.683 63.5078C40.8862 63.5078 41.0894 63.5078 41.3039 63.5078C52.2535 63.3498 60.9681 59.2747 64.7383 55.3013C66.2736 53.6758 67.0637 52.0502 67.0073 50.5941C66.8831 47.0044 61.2616 44.1597 51.9826 42.9858L52.2309 40.9877C62.8758 42.331 68.836 45.7175 69.0166 50.515C69.0843 52.5243 68.1135 54.6578 66.1945 56.6784C61.239 61.8936 51.4859 65.3591 41.3378 65.5059C41.1233 65.5059 40.9088 65.5059 40.683 65.5059V65.5172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4074 54.9739C25.9067 54.9739 18.5128 52.276 18.1968 52.1519L18.8966 50.2667C18.9757 50.3006 26.8549 53.1565 40.9088 52.942C54.9514 52.7276 62.6161 49.6459 62.6951 49.612L63.4628 51.4633C63.1354 51.5987 55.4142 54.7369 40.9426 54.9514C40.4234 54.9514 39.9154 54.9514 39.4187 54.9514L39.4074 54.9739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8073 13.6927C37.4999 18.6031 31.1446 28.898 31.1446 33.0859C31.1446 38.414 35.4793 42.7487 40.8073 42.7487C46.1354 42.7487 50.4701 38.414 50.4701 33.0859C50.4701 28.898 44.1148 18.6031 40.8073 13.6927ZM40.8073 44.758C34.373 44.758 29.1353 39.5203 29.1353 33.0859C29.1353 26.6516 39.543 11.9769 39.9833 11.3334C40.1752 11.0625 40.48 10.9045 40.8073 10.9045C41.1347 10.9045 41.4395 11.0625 41.6314 11.3334C42.0716 11.9656 52.4794 26.9451 52.4794 33.0859C52.4794 39.2268 47.2416 44.758 40.8073 44.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1978 39.9605V37.9512C40.796 37.9512 41.383 37.8609 41.9361 37.6803C43.7536 37.0933 45.1533 35.6597 45.6839 33.8197L47.6142 34.3728C46.903 36.8563 45.0178 38.8091 42.557 39.5993C41.8007 39.8364 41.0105 39.9605 40.209 39.9605H40.1978Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3426_554",
    x1: 39.9944,
    y1: 0,
    x2: 39.9944,
    y2: 79.9887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D008B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3426_554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.13f1ea5a0368b3484f4732e6b062e572.svg";
export { ForwardRef as ReactComponent };